export default __webpack_public_path__ + "static/media/paytm.d01a7296.svg";